import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { AppLoadService } from './app-load.service';
export function init_app(appLoadService: AppLoadService): any {
  return () => appLoadService.initializeApp();
}

@NgModule({
  imports: [],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = init_app(inject(AppLoadService));
      return initializerFn();
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppLoadModule {}
